import { Spinner, Typography } from '@flex-design-system/fx';
import { byteToMebibyte } from '@flex-packages/utils';
import type { FileType } from '@flex-services/file/hooks';

import { CandidateAttachmentFileAvatar } from '../../CandidateAttachmentFile';

import { Container, FileContentInfo } from './style';

interface FilePreviewProps {
  file: FileType;
}

export const FilePreview = ({ file }: FilePreviewProps) => {
  const isLoading = file.status === 'loading';

  return (
    <Container align="center">
      {isLoading ? (
        <Spinner size={22} />
      ) : (
        <CandidateAttachmentFileAvatar
          fileName={file.name}
          mimeType={file.file?.type}
        />
      )}
      <FileContentInfo
        weight={500}
        size={14}
        color="grayDarker"
        ellipsis={true}
      >
        {`${file.name} `}
        {file.file && (
          <Typography size={11} color="grayLight">
            {byteToMebibyte(file.file.size).toFixed(1)}MB
          </Typography>
        )}
      </FileContentInfo>
    </Container>
  );
};
